import { useMatches } from '@ubo/losse-sjedel'

export default function useIsLighthouse() {
  const matches = useMatches() as any

  return !!matches?.[0]?.data?.isLighthouse
}
